<template>
  <v-row class="pt-6">
    <v-sheet width="100%" height="100%">
      <div class="pa-2">
        <p class="text-h1">{{ type }}</p>
        <p class="text-h6">You do not have access to view the current page.</p>
        <p class="text-h6">
          If you believe you have reached this in an error please contact your Core Facility
          Administrator to request access.
        </p>
      </div>

      <v-row>
        <v-col cols="2">
          <v-btn color="primary" large @click="ret_home">Back To Home</v-btn>
        </v-col>
        <v-col cols="2">
          <div v-if="error">
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" v-on="on" large class="ma-0"> Log </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 primary white--text" primary-title>
                  Here's what went wrong.
                </v-card-title>

                <v-card-text>
                  {{ error }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog = false" color="primary"> Close </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
  </v-row>
</template>

<script>
export default {
  data: function () {
    return {
      dialog: false,
    }
  },
  props: {
    error: Object,
    type: String,
  },
  methods: {
    ret_home: function () {
      this.$router.push(`/`)
    },
  },
}
</script>
